import {type FunctionalComponent, h,type JSX, type VNode} from '@stencil/core';
import type {GuidedV2LinkAttribute, GuidedV2LinkTag} from '../../models/quick-link';
import type {GuidedV2Emitters} from '../../models/eventNames';



type QdsImportance = 'emphasized' | 'standard' | 'subdued';

type FallbackRenderLinkProps = {
  title: string | JSX.Element,
  description?: string | JSX.Element,
  url: string,
  tags: {
    attributes: Array<GuidedV2LinkAttribute>,
    tags: Array<GuidedV2LinkTag>
  },
  eventEmitters: GuidedV2Emitters,
  category?: string
};
// Specific templated related to quick-links are to be defined within `result-items` directory.

const getImportance = (importance:QdsImportance):string => {
    switch(importance){
    case 'emphasized':
      return 'emphasized';
    default:
    case 'standard':
      return 'standard';
    }
};

export const GuidedV2LinkAttributeRender = (props: {
  attribute: GuidedV2LinkAttribute
})=>{
    const {attribute} = props;
    const importance = getImportance(attribute?.importance);

    // qds-tag doesn't allow markup within elements
    // const val = attribute.attributeValue;
    const val = attribute.attributeValueMarkup ?? attribute.attributeValue;

    let displayAttribute = [val];
    if(attribute.attributeName)
      displayAttribute = [`${attribute.attributeName}: `, val];

    if(!val){
      return <span class={'invalid-attribute'} data-value={JSON.stringify(attribute)}></span>;
    }

    return (
      <span class={`guided-v2-result-list-section__result-extra-info guided-v2-result-list-attribute guided-v2-importance__${importance}`}>
        {displayAttribute}
      </span>
    );
};

export const GuidedV2LinkTagRender = (props: {
  tag:GuidedV2LinkTag,
}) =>{
    const {tag} = props;
    const importance:QdsImportance = tag?.importance ?? 'standard';
    // const text = tag?.tagMarkup as string ?? tag.tagText; //qds-tag doesn't allow markup within elements
    const text = tag.tagText;


    if(!text || text == '')
      return <span class="invalid-tag" data-value={JSON.stringify(tag)}></span>;

    return (
      <qds-tag
        status={tag.color}
        importance={importance}
        text={text}
        icon-name={tag.iconName}
        size="small"
      />
    );
};

export const GuidedV2FallbackQuickRenderLink: FunctionalComponent<FallbackRenderLinkProps> = (props)=>{

    const {title, description, url, tags, eventEmitters, category} = props;

    const emitters = eventEmitters() ?? undefined;

    if(emitters == undefined){
      console.error("No event emitters found"); //eslint-disable-line
    }
    const clickEmitter = (ev:MouseEvent) => {
        const clickEvent = emitters.completed.emit({
          link: url,
          event: 'guidedSearchClick',
          category: category
        });

        if (clickEvent.defaultPrevented) {
          ev.preventDefault();
        }
    };

    return <li class="guided-v2-result-list-section__result add-selector-strength">
      <a class="guided-v2-result-list-section__result-link add-selector-strength" href={url} onClick={clickEmitter}>

        <div class="guided-v2-result-list-section__result-title add-selector-strength" >
          {title}
          {description && <span>- {description}</span>}
        </div>

        <div class="guided-v2-result-list-section__result-extra add-selector-strength">

          {tags.attributes.map(attribute=><GuidedV2LinkAttributeRender
            attribute={attribute}
          ></GuidedV2LinkAttributeRender>)}

          {tags.tags.map(tag=><GuidedV2LinkTagRender
            tag={tag}
          ></GuidedV2LinkTagRender>)}

        </div>
      </a>
    </li> as VNode;
};
